/**
 * Tab navigation for License Management page.
 *
 * Extracted from LicenseManagementPage.tsx (Sub-PR 6.3).
 */

import { Key, FileCheck, Zap, FileText } from 'lucide-react'
import type { TabId } from './helpers'

export function TabNavigation({
  activeTab,
  onTabChange,
}: {
  activeTab: TabId
  onTabChange: (tab: TabId) => void
}): React.ReactElement {
  const tabs = [
    { id: 'licenses' as TabId, label: 'Licenses', icon: Key },
    { id: 'criteria' as TabId, label: 'License Criteria', icon: FileCheck },
    { id: 'activation' as TabId, label: 'Payments', icon: Zap },
    { id: 'reports' as TabId, label: 'Reports', icon: FileText },
  ]

  return (
    <div className="border-b border-stone-200 dark:border-stone-700">
      <nav className="-mb-px flex space-x-8" aria-label="Tabs">
        {tabs.map((tab) => {
          const Icon = tab.icon
          const isActive = activeTab === tab.id
          return (
            <button
              key={tab.id}
              onClick={() => {
                onTabChange(tab.id)
              }}
              className={`flex items-center gap-2 border-b-2 px-1 py-4 text-sm font-medium transition-colors ${
                isActive
                  ? 'border-[#4e5e82] text-[#5c6e94] dark:text-[#8a9bba]'
                  : 'border-transparent text-stone-500 hover:border-stone-300 hover:text-stone-700 dark:text-stone-400 dark:hover:text-stone-300'
              }`}
            >
              <Icon className="h-4 w-4" />
              {tab.label}
            </button>
          )
        })}
      </nav>
    </div>
  )
}
